import React from "react";
import { Link } from "react-router-dom";
import { UserRoundPen, ArrowRight } from "lucide-react";
import { LAWYER_BASE } from "@lawyer/constants/route";

// Shown only while client-visible profile fields are empty; disappears once the profile is complete.
export default function CompleteProfileBanner({ missing }) {
  if (!missing?.length) return null;
  return (
    <div
      className="rounded-2xl border border-[#D4AF37]/50 bg-[#FBF4DF] px-5 sm:px-6 py-5 flex flex-col sm:flex-row sm:items-center gap-4"
      data-testid="complete-profile-banner"
    >
      <div className="h-11 w-11 shrink-0 rounded-xl bg-[#0A2540] text-[#D4AF37] grid place-items-center">
        <UserRoundPen size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-lg font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Complete your profile</p>
        <p className="mt-0.5 text-sm text-slate-700">
          Clients see this before they book. Still missing:{" "}
          <span className="font-bold" data-testid="complete-profile-missing">{missing.join(", ")}</span>.
          {missing.includes("Profile photo") && (
            <span className="block mt-1 text-xs text-slate-600" data-testid="complete-profile-photo-hint">
              Profiles with a real photo earn far more client trust and bookings.
            </span>
          )}
        </p>
      </div>
      <Link
        to={`${LAWYER_BASE}/profile`}
        className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-xl adv-btn-primary font-extrabold text-sm"
        data-testid="complete-profile-cta"
      >
        Complete profile <ArrowRight size={16} />
      </Link>
    </div>
  );
}
